import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { employeeStateSelector } from '~/selectors';

import { Employee } from './types';

export const useEmployee = (): {
  employee: Employee;
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return employeeStateSelector(state);
  });
};
